<template>
  <div class="fit">
    <q-card class="column fit">
      <q-btn
        style="position: absolute; z-index: 2; right: 5px; top: 5px"
        flat
        icon="close"
        @click="$emit('closeReport')"
      ></q-btn>
      <googleMaps
        ref="gmapReport"
        :center="{ lng: coords.lng, lat: coords.lat }"
        :zoom="5"
        :upperLimit="upperLimit"
        :lowerLimit="lowerLimit"
        mapType="roadmap"
        :normalizedData="normalizedData"
        :profileData="currentZoomScanData"
        :overlayAllData="overlayAllData"
        :polyline="line"
        :dot="dot"
        :showRangeCircles="graph"
        :options="{
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: true,
        }"
        :pathsMaxDistance="distanceLevels[currentZoom] * 3"
        style="height: 100%; width: 100%; position: relative; z-index: 1"
        @dotClicked="dotClicked"
        @zoomLevelChanged="handleNewZoomLevel"
      >
      </googleMaps>
    </q-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import googleMaps from "@/components/googleMaps/googleMaps.vue";

export default {
  components: { googleMaps },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentZoomScanData",
      "currentZoomScanDataLoading",
      "currentZoom",
      "currentMapIndex",
      "currentSelectedIndexRelative",
      "currentViewedReports",
      "survey",
      "surveyLoading",
    ]),
  },
  data: () => ({
    dot: true,
    line: true,
    graph: false,
    coords: {
      lat: -40.900558,
      lng: 174.885971,
    },
    upperLimit: 12,
    lowerLimit: 6,
    overlayAllData: false,
    normalizedData: [],
    position: 0,
    strokeColors: ["#008000", "#eb9c34", "#eb4034"],

    // Zoom Level Debounce
    debouncedSearchOrders: "",
    zoomDebounce: null,
    distanceLevels: [
      200000, 100000, 50000, 30000, 15000, 7000, 4000, 2000, 1000, 500, 200,
      100, 50, 30, 10, 5, 2, 1, 0.5,
    ],
  }),
  beforeCreate() {},
  watch: {
    currentZoomScanData: function () {
      this.updateNormalizationData();
    },
    currentMapIndex: function () {
      this.updateNormalizationData();
    },
    survey: function () {
      this.initialScanLoad();
    },
  },
  mounted() {
    if (this.survey && !this.surveyLoading) {
      console.log(1);
      this.initialScanLoad();
    }
  },
  methods: {
    initialScanLoad() {
      let ids = this.survey.mergedScans
        ? this.survey.mergedScans.map((scan) => scan.merged_id)
        : [this.survey.id];

      // If its a different scan to what is currently loaded, then load from fresh, otherwise only update upper and lower limits
      if (
        this.currentViewedReports.length == 0 ||
        !this.currentViewedReports[0].includes(ids[0]) ||
        this.normalizedData.length == 0
      ) {
        this.$store
          .dispatch("loadSurveyScanDataForZoom", {
            idList: [ids],
            zoom: 8,
          })
          .then(() => {
            this.init();
          });
      } else {
        this.lowerLimit = this.survey.lowerLimit;
        this.upperLimit = this.survey.upperLimit;
      }
    },
    init() {
      this.$store.dispatch("changeCurrentMapIndex", 0);
      this.normalizedData = this.currentZoomScanData[0].normalizedData;
      this.lowerLimit = this.currentZoomScanData[0].lowerLimit;
      this.upperLimit = this.currentZoomScanData[0].upperLimit;
      setTimeout(() => {
        this.highlightPoint(0);
        this.$refs.gmapReport.zoomToBounds(
          this.calculateNESWBounds(0, this.normalizedData.length - 1)
        );
        // console.log(this.$refs.gmapReport.zoom);
      }, 200);
    },
    setPosition(position) {
      this.coords.lng = position.lng;
      this.coords.lat = position.lat;
    },
    updateCenterPOS(pos, point) {
      this.$refs.gmapReport.panToLocation(pos);
      this.position = point;
    },
    highlightPoint(index) {
      this.position = index;
      this.$refs.gmapReport.panToLocation(this.normalizedData[index], true);
    },
    runError(error) {
      this.$q.notify({
        position: "top-right",
        type: "error",
        message: error.message,
      });
    },
    rangeChanged(min, max) {
      let middle = Math.floor((max + min) / 2);
      this.updateCenterPOS(this.normalizedData[middle], middle);
      this.$refs.gmapReport.zoomToBounds(this.calculateNESWBounds(min, max));
      this.$refs.gmapReport.drawRangePoints(
        this.normalizedData[min],
        this.normalizedData[max]
      );
    },
    calculateNESWBounds(min, max) {
      let data = {
        maxLng: -500,
        minLng: 500,
        maxLat: -500,
        minLat: 500,
      };
      for (let index = min; index <= max; index++) {
        data.maxLat =
          this.normalizedData[index].lat > data.maxLat
            ? this.normalizedData[index].lat
            : data.maxLat;

        data.minLat =
          this.normalizedData[index].lat < data.minLat
            ? this.normalizedData[index].lat
            : data.minLat;

        data.maxLng =
          this.normalizedData[index].lng > data.maxLng
            ? this.normalizedData[index].lng
            : data.maxLng;

        data.minLng =
          this.normalizedData[index].lng < data.minLng
            ? this.normalizedData[index].lng
            : data.minLng;
      }
      return data;
    },
    dotClicked(point) {
      this.$store.dispatch("changeSelectedIndex", point);
    },
    toggleGraph(value) {
      this.graph = value;
    },
    getColor(value) {
      let color =
        this.strokeColors[
          value < this.lowerLimit ? 0 : value > this.upperLimit ? 2 : 1
        ];
      return color;
    },
    roundTwoDP(val) {
      return Math.round((parseFloat(val) + Number.EPSILON) * 100) / 100;
    },
    changeDisplayedMap() {
      this.normalizedData =
        this.currentZoomScanData[this.currentMapIndex].normalizedData;
    },
    handleNewZoomLevel(zoom) {
      if (
        (zoom > this.currentZoom || zoom <= this.currentZoom - 3) &&
        zoom <= 18
      ) {
        clearTimeout(this.zoomDebounce);
        this.zoomDebounce = setTimeout(() => {
          this.$store.dispatch("loadSurveyScanDataForZoom", {
            idList: this.currentViewedReports,
            zoom: zoom,
          });
        }, 1000);
      }
    },
    updateNormalizationData() {
      this.$store.dispatch(
        "changeSelectedIndex",
        Math.round(
          this.currentZoomScanData[this.currentMapIndex].normalizedData.length *
            this.currentSelectedIndexRelative
        )
      );
      setTimeout(() => {
        this.normalizedData =
          this.currentZoomScanData[this.currentMapIndex].normalizedData;
      }, 500);
    },
  },
};
</script>

<style>
#reportSlider > .q-slider__track-container {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>
